export default __webpack_public_path__ + "static/media/scanrfid2.68bfb54d.png";